import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X, Tag } from "lucide-react";
import { Button } from "./ui/button";
import { useState } from "react";
import { BookingModal } from "./BookingModal";
import { DiscountModal } from "./DiscountModal";
export const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

const navLinks = [
  { name: "Home", path: "/" },
  { name: "AI Solutions", path: "/ai-services" },
  { name: "Features", path: "/features" },
  { name: "Serviced Areas", path: "/serviced-areas" },
  { name: "Buy Now", path: "/buy-now" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact", path: "/contact" },
];

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background text-foreground shadow-sm">
      <div className="container mx-auto flex h-20 items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white p-1 shadow-sm border border-border/50">
<picture>
              <source srcSet="https://wsrv.nl/?url=https%3A%2F%2Fvibe.filesafe.space%2F1776204073728798439%2Fattachments%2Fc60387b0-6ed4-41b6-bd27-ec59d975e577.jpg&output=webp" type="image/webp" />
              <img 
                src="https://vibe.filesafe.space/1776204073728798439/attachments/c60387b0-6ed4-41b6-bd27-ec59d975e577.jpg" 
                alt="Missed Call Rescue Logo" 
                className="h-full w-full object-contain rounded-full"
                loading="eager"
                decoding="async"
                width={48}
                height={48}
              />
            </picture>
          </div>
          <div className="flex flex-col">
            <span className="text-xl font-bold leading-tight tracking-tight text-primary">Missed Call</span>
            <span className="text-sm font-semibold tracking-widest text-secondary">RESCUE</span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors hover:text-primary ${
                location.pathname === link.path ? "text-primary font-bold" : "text-muted-foreground"
              }`}
            >
              {link.name}
            </Link>
          ))}
          <DiscountModal>
            <Button variant="outline" className="border-primary text-primary hover:bg-primary/5 font-semibold cursor-pointer">
              <Tag className="mr-2 h-4 w-4" />
              30% Off Annual
            </Button>
          </DiscountModal>
          <BookingModal>
            <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90 border-none cursor-pointer">
              <Phone className="mr-2 h-4 w-4" />
              Get Started
            </Button>
          </BookingModal>
        </nav>

        {/* Mobile Menu Toggle */}
        <button 
          className="md:hidden p-2 text-foreground hover:text-primary transition-colors"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-border bg-background px-4 py-4 shadow-lg absolute w-full">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium py-2 transition-colors hover:text-primary ${
                  location.pathname === link.path ? "text-primary font-bold" : "text-muted-foreground"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <DiscountModal>
              <Button variant="outline" className="border-primary text-primary hover:bg-primary/5 w-full mt-2 font-semibold cursor-pointer" onClick={() => setIsMenuOpen(false)}>
                <Tag className="mr-2 h-4 w-4" />
                30% Off Annual
              </Button>
            </DiscountModal>
            <BookingModal>
              <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90 w-full mt-2 cursor-pointer" onClick={() => setIsMenuOpen(false)}>
                <Phone className="mr-2 h-4 w-4" />
                Get Started
              </Button>
            </BookingModal>
          </nav>
        </div>
      )}
    </header>
  );
};
